import { logout } from '../actions';
import {
  GET_USER_SUCCESS,
  GET_USER_FAIL,
  LOGIN_SUCCESSFUL,
} from '../actions/actionTypes';

const user = (state = { isSignedIn: false }, action) => {
  switch (action.type) {
    case LOGIN_SUCCESSFUL:
      return {
        ...state,
        isSignedIn: true,
      };
    case GET_USER_SUCCESS:
      action.payload.isSignedIn = true;
      return action.payload;
    case GET_USER_FAIL:
      logout();
      return { isSignedIn: false };
    default:
      return state;
  }
};

export default user;
